import { createStore } from 'vuex';
export default createStore({
    state: {
      authInfo: {}
    },
    mutations: {
      setAuthInfo(state, authInfo) {
        state.authInfo = authInfo;
      },
    }
});